export default {
  NWMISSOURI_EDU: 'nwmissouri.edu',
  OREGONSTATE_EDU: 'oregonstate.edu',
  WSU_EDU: 'wsu.edu',
  EWU_EDU: 'ewu.edu',
  SAGE_HILL_SCHOOL: 'sagehillschool.org',
  MSUTEXAS_EDU: 'msutexas.edu',
  WOU_EDU: 'wou.edu',
  PURDUE_EDU: 'purdue.edu',
  APSU_EDU: 'apsu.edu',
};
